import { safeJson } from "@/lib/http";
const API = `${process.env.REACT_APP_BACKEND_URL}/api/portail`;

async function j(r) {
    const body = await safeJson(r);
    if (!r.ok) throw new Error(typeof body.detail === "string" ? body.detail : `Erreur ${r.status}`);
    return body;
}

export const fetchPortail = (token) => fetch(`${API}/${token}`).then(j);

export const fetchPortailQuestionnaire = (token, email) =>
    fetch(`${API}/${token}/questionnaire?email=${encodeURIComponent(email)}`).then(j);

export const savePortailQuestionnaire = (token, email, reponses) =>
    fetch(`${API}/${token}/questionnaire`, {
        method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, reponses }),
    }).then(j);

export function uploadPortailDocument(token, { file, email, typeDocument, periode, typePersonnalise, estHolding }) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("email", email);
    fd.append("type_document", typeDocument);
    fd.append("periode", periode || "");
    fd.append("type_personnalise", typePersonnalise || "");
    fd.append("est_holding", estHolding ? "true" : "false");
    return fetch(`${API}/${token}/documents`, { method: "POST", body: fd }).then(j);
}

export async function fetchPortailPrevisionnel(token, email) {
    const r = await fetch(`${API}/${token}/previsionnel?email=${encodeURIComponent(email)}`);
    const j = await safeJson(r);
    if (!r.ok) throw new Error(j.detail || `Erreur ${r.status}`);
    return j;
}

// SUPER-LOT 84 — Boucle de signature client : dépôt de la version signée (route token sécurisée).
export function uploadPortailSignedDocument(token, docId, { file, email }) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("email", email);
    return fetch(`${API}/${token}/documents/${docId}/signed`, { method: "POST", body: fd }).then(j);
}

export const portailLivrableDownloadUrl = (token, docId, email) =>
    fetch(`${API}/${token}/documents/${docId}/download?email=${encodeURIComponent(email)}`).then(j).then((r) => r.url);

export async function savePortailPrevisionnel(token, email, data) {
    const r = await fetch(`${API}/${token}/previsionnel`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, ...data }) });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(j.detail || `Erreur ${r.status}`);
    return j;
}

export const extractSalariesPortail = (token, email, instruction) =>
    fetch(`${API}/${token}/extract-salaries`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, instruction }) }).then(j);

export const extractIdentitePortail = (token, email) =>
    fetch(`${API}/${token}/extract-identite-dirigeant`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email }) }).then(j);

export const extractBanquesPortail = (token, email) =>
    fetch(`${API}/${token}/extract-comptes-bancaires`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email }) }).then(j);

export const fetchEtablissementsPortail = (token, email) =>
    fetch(`${API}/${token}/etablissements?email=${encodeURIComponent(email)}`).then(j);

export const extractCapitalPortail = (token, email) =>
    fetch(`${API}/${token}/extract-repartition-capital`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email }) }).then(j);

export const extractDateJugementPortail = (token, email, docId) =>
    fetch(`${API}/${token}/documents/${docId}/extract-date-jugement`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email }) }).then(j);

export const dateJugementStatutPortail = (token, email, docId) =>
    fetch(`${API}/${token}/documents/${docId}/date-jugement-statut?email=${encodeURIComponent(email)}`).then(j);

export const magicFillPortail = async (token, email, section, instruction, documentIds) => {
    const { job_id, dossier_id } = await fetch(`${API}/${token}/magic-fill/jobs`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, section_cible: section, instructions_user: instruction, document_ids: documentIds || [] }) }).then(j);
    for (;;) {
        await new Promise((r) => setTimeout(r, 2500));
        const jb = await fetch(`${API}/${token}/magic-fill/jobs/${job_id}?dossier_id=${encodeURIComponent(dossier_id)}`).then(j);
        if (jb.stage === "done") return jb.result || { lignes: [] };
        if (jb.stage === "error") throw new Error(jb.error || "Extraction en erreur");
    }
};
